import React, { Component } from 'react';
import { Modal, Tabs, Button, Checkbox, message, Radio } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import TableC from '../../basicElement/TableC';
import format from '../../shared/format';
import moment from 'moment';

const { TabPane } = Tabs;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
const basicOptions = [
    { label: '确认FTE（含项目&非项目）', value: 'userFte' },
    { label: '确认标准访视数', value: 'userStandardVisit' },
    { label: '完成访视数', value: 'userVisitCount' },
];

class ExportModal extends Component {
    state = {
        visible: false,
        value: null,
    }

    show = () => {
        this.setState({
            visible: true,
            value: null,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleCheckChange = (value) => {
        this.setState({ value });
    }

    submit = () => {
        const { sortParams, curParams, activeKey } = this.props;
        const { value } = this.state;
        if (!value) {
            message.warning('请选择导出内容！');
            return;
        }
        this.export(
            API_URL.dashboard.exportUserOutPutList, 
            { 
                ...sortParams, 
                ...curParams, 
                activeKey, 
                type: value, 
                offset: 1,
                upToNow:sortParams.upToNow ? 1 : 0 
            }
            )
        this.hide();
    }

    export = (url, data) => {
        const options = {
            method: 'POST',
            url,
            data,
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
            },
        };
        $.sendRequest(options);
    }

    onChange = (e) => {
        this.setState({
            value: e.target.value,
        });
    }

    render() {
        const { visible, values, value } = this.state;
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
        };
        return (
            <Modal
                title="导出"
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                width={380}
                footer={<div>
                    <Button onClick={this.hide}>取消</Button><Button type="primary" onClick={this.submit}>确定</Button>
                </div>}
            >
                <div style={{padding:'0 20px'}}>
                    <div style={{marginBottom: 15}}>请选择导出内容:</div>
                    <div style={{ marginLeft: 35, width: 210, lineHeight: '30px' }}>
                    <RadioGroup onChange={this.onChange} value={value}>
                        {
                            basicOptions.map(el => <Radio style={radioStyle} value={el.value}>{el.label}</Radio>)
                        }
                    </RadioGroup>
                    </div>
                </div>
            </Modal>
        );
    }
}

class Filter extends Component {

    disabledDate = (current, key) => {
        const { params } = this.props; 
        const currentValue = current.valueOf();
        if ( key == 'beginDate'){
            return current && (currentValue < moment(params.endDate).add(-11, 'M') || currentValue > moment(params.endDate));
        }else {
            return current && ( currentValue < moment(params.beginDate) || currentValue > moment(params.beginDate).add(11, 'M') );
        }
        
    };

    render() {
        const { areaOptions, activeKey, params, ...rest } = this.props;
        const filters = [{
            name: '统计时间',
            key: 'beginDate',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
                disabled: params.upToNow ? params.upToNow == 1 : false,
                // disabledDate:(current) => this.disabledDate(current, 'beginDate')
            }
        }, {
            name: '至',
            key: 'endDate',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
                disabled: params.upToNow ? params.upToNow == 1 : false,
                // disabledDate:(current) => this.disabledDate(current, 'endDate')
            }
        },{
            name: '',
            key: 'upToNow',
            type: 'Checkbox',
            typeProperty: {
                value: '入职-至今',
            }
        }];
        return (
            <FilterBasic filters={filters} params={params} {...rest} />
        )
    }
}

class CrcOutput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            panes: [{
                title: '确认FTE',
                key: 'userFte',
            }, {
                title: '确认标准访视数',
                key: 'userStandardVisit',
            }, {
                title: '完成访视数',
                key: 'userVisitCount',
            }],
            activeKey: 'userFte',
            searchParams: {},
            curParams: {},
            sortParams: {},
            loading: false,
            data:[],
            dateList:[],
            pagination: {
                pageSize: 10,
                current: 1,
            },
        };
    }

    componentDidMount() {
        this.queryEffectiveDate();
    }

    loadData = () => {
        const { sortParams, pagination, searchParams, activeKey } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryUserOutPutList,
            data: {
                type: activeKey,
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
                upToNow:(sortParams.upToNow || searchParams.upToNow) ? 1 : 0
            },
            dataType: 'json',
            doneResult: res => {
                const { data,datas ,totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    dateList: data,
                    pagination,
                    columns: this.getColumns(activeKey),
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const {date } = res;
            const { searchParams } = this.state;
            searchParams.beginDate = format('month', date);
            searchParams.endDate = format('month', date);
            this.setState({
                searchParams,
                curParams: {...searchParams}
            },this.loadData);
        });
    }

    search = () => {
        const { searchParams } = this.state;
        this.setState({ curParams: {...searchParams} },this.loadData);
    }

    export = () => {
        this.exportRef.show();
    }
    
    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getDateColimns = type => {
        const { dateList } = this.state;
        const dateCol = [];
        dateList.map((el, index) => {
            dateCol.push({
                title: el,
                dataIndex: 'firstArr',
                key: `${index}${type}`,
                width: dateList.length == 1 ? 100 : 80,
                render: text => {
                    return type ? text[index] : text[index + text.length/2]
                }
            })
        })
        return dateCol
    }

    getColumns = activeKey => {
        
        const columns = [{
            title: '区域',
            dataIndex: 'areaName',
            fixed: 'left',
            key: 'areaName',
            width: 90,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            fixed: 'left',
            key: 'cityName',
            width: 90,
        }, {
            title: 'CRC姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 105,
        }, {
            title: 'CRC工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 120,
        }, {
            title: '入职时间',
            dataIndex: 'joinTime',
            key: 'joinTime',
            width: 100,
            render: text => text.slice(0,7)
        }, {
            title: '职位',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 120,
        }, {
            title: '主管姓名',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 95,
        }, {
            title: '主管工号',
            dataIndex: 'leaderCode',
            key: 'leaderCode',
            width: 95,
        }];
        if( activeKey === 'userFte' ) {
            columns.push(
                {
                    title: '项目确认FTE',
                    children:this.getDateColimns(true),
                }, {
                    title: '非项目确认FTE',
                    children:this.getDateColimns(false),
                }
            )
        }else {
            columns.push(...this.getDateColimns(true))
        }
        return columns;
    }

    getDataSource = () => {
        const { data = [] } = this.state;
        return data;
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey },this.loadData);
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { panes, activeKey, areaOptions, searchParams, sortParams, curParams, pagination, loading, columns } = this.state;
        return (
            <div>
                <div className="reportTitle">{this.props.title}</div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    areaOptions={areaOptions}
                    activeKey={activeKey}
                    onChange={this.handleFilterChange}
                    buttons={[
                            <Button key="export" type="primary" onClick={this.export} style={{marginLeft: 8}}>导出</Button>
                    ]}
                />
                <div style={{marginTop: -20, marginBottom: 4, color: '#ffa500'}}>注：由于数据量过大，页面仅展示一个人员数据，请导出后查看完整数据</div>
                <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                    {panes.map(pane => <TabPane tab={pane.title} key={pane.key}></TabPane>)}
                </Tabs>
                <TableC
                    loading={loading}
                    columns={this.getColumns(activeKey)}
                    data={this.getDataSource()}
                    sortParams={sortParams}
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
                <ExportModal ref={el => this.exportRef = el} sortParams={sortParams} curParams={curParams} activeKey={activeKey}/>
            </div>
        );
    }
}

export default CrcOutput;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/crcOutput.js